import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ChevronRight({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M10.2071 18.7071L8.79285 17.2929L14.0857 12L8.79285 6.70709L10.2071 5.29288L16.9142 12L10.2071 18.7071Z"
        fill={iconColor}
      />
    </Svg>
  );
}
